var _style, _circle, _g, _g2, _circle2, _circle3, _g3, _g4, _g5, _g6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmptyNews = function SvgEmptyNews(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#B8B9BC;}\r\n\t.st2{fill:#ECECEC;}\r\n\t.st3{fill:#DEDEDE;}\r\n\t.st4{fill:#F2F2F2;}\r\n\t.st5{fill:#A3A3A3;}\r\n\t.st6{fill:#DDDDDD;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 540,
    cy: 540,
    r: 540
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_36---Select-Email"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M852.2,755.3V561.5c0-11.9-9.6-21.5-21.5-21.5H249.3c-11.9,0-21.5,9.6-21.5,21.5v193.8H852.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st2",
    d: "M819.9,755.3V561.5c0.3-11.6-8.8-21.2-20.4-21.5H248.2c-11.6,0.3-20.7,10-20.4,21.5v193.8 H819.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    className: "st3",
    d: "M776.9,249.3v495.3H303.1V249.3c0-11.9,9.7-21.5,21.5-21.5h430.7 C767.2,227.8,776.8,237.4,776.9,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    className: "st4",
    d: "M744.6,249.3v495.3H303.1V249.3c-0.4-11.5,8.6-21.1,20.1-21.5h401.3 C736,228.2,744.9,237.8,744.6,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    className: "st3",
    d: "M852.2,658.4v150.7c0,11.4-4.5,22.4-12.6,30.5c-8.1,8.1-19,12.6-30.5,12.6H270.8 c-11.4,0-22.4-4.5-30.5-12.6c-8.1-8.1-12.6-19-12.6-30.5l0-150.7H405c3.6,0,7,1.8,9,4.8l36.6,54.9c2,3,5.4,4.8,9,4.8h160.6 c3.6,0,7-1.8,9-4.8l36.6-54.9c2-3,5.4-4.8,9-4.8H852.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    className: "st0",
    d: "M486.2,626.1c-12.4,0-24.2-5.4-32.4-14.7l-75.4-86.1c-15.7-17.9-13.8-45.1,4.1-60.8 c17.9-15.7,45.1-13.8,60.8,4.1l40.1,45.9l151.2-204.6c9.1-12.5,24.2-19.2,39.6-17.5c15.4,1.7,28.7,11.5,34.8,25.7 c6.1,14.2,4.2,30.6-5.1,43l-183,247.6c-7.7,10.5-19.8,16.9-32.9,17.4l-1.5,0H486.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    className: "st4",
    d: "M703.9,361.1l-183,247.6c-7.7,10.5-19.8,16.9-32.8,17.4h-1.8c-12.4,0-24.2-5.4-32.4-14.8 l-11.3-12.9c6.7,4,14.4,6.2,22.2,6.1h1.7c13.1-0.5,25.2-6.9,32.9-17.4l183-247.6c6.7-9.2,9.6-20.7,8-32 c-0.6-3.9-1.7-7.7-3.3-11.3c2.8,1.2,5.4,2.7,7.9,4.5c9.2,6.8,15.3,17,17,28.3C713.5,340.4,710.6,351.9,703.9,361.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    className: "st4",
    d: "M819.9,658.4v150.7c0,11.4-4.5,22.4-12.6,30.5c-8.1,8.1-19,12.6-30.5,12.6h-506 c-11.4,0-22.4-4.5-30.5-12.6c-8.1-8.1-12.6-19-12.6-30.5l0-150.7h171.4c3.6,0,7,1.8,9,4.8l36.6,54.9c2,3,5.4,4.8,9,4.8h166.5 c3.6,0,7-1.8,9-4.8l36.6-54.9c2-3,5.4-4.8,9-4.8H819.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    className: "st0",
    d: "M303.1,658.4h32.3V249.3c-0.4-11.5,8.6-21.1,20.1-21.5h-32.3c-11.5,0.5-20.4,10.1-20.1,21.5 V658.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_9_",
    className: "st0",
    d: "M270.8,852.2h32.3c-11.4,0-22.4-4.5-30.5-12.6c-8.1-8.1-12.6-19-12.6-30.5V561.5 c-0.3-11.6,8.8-21.2,20.4-21.5h-32.3c-11.6,0.3-20.7,10-20.4,21.5v247.6c0,11.4,4.5,22.4,12.6,30.5 C248.5,847.7,259.4,852.2,270.8,852.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10_",
    className: "st5",
    d: "M809.2,863H270.8c-29.7,0-53.8-24.1-53.8-53.8V658.4c0-5.9,4.8-10.8,10.8-10.8H405 c7.2,0,13.9,3.6,17.9,9.6l36.7,55h160.7l36.7-55c4-6,10.7-9.6,17.9-9.6h177.3c5.9,0,10.8,4.8,10.8,10.8v150.7 C863,838.9,838.9,863,809.2,863L809.2,863z M238.5,669.2v140c0,17.8,14.5,32.3,32.3,32.3h538.3c17.8,0,32.3-14.5,32.3-32.3v-140 H675l-36.7,55c-4,6-10.7,9.6-17.9,9.6H459.6c-7.2,0-13.9-3.6-17.9-9.6l-36.7-55H238.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_",
    className: "st0",
    d: "M313.9,249.3v140v269.2h-21.5V389.3v-140H313.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_",
    className: "st5",
    d: "M303.1,303.1c5.9,0,10.7-4.8,10.8-10.8v-43.1h-21.5v43.1 C292.4,298.3,297.2,303.1,303.1,303.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13_",
    className: "st5",
    d: "M292.4,658.4h21.5V378.5c0-5.9-4.8-10.8-10.8-10.8c-5.9,0-10.8,4.8-10.8,10.8V658.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_14_",
    className: "st5",
    d: "M313.9,335.4c0-2.9-1.2-5.6-3.1-7.6l-1.6-1.3c-0.6-0.4-1.3-0.7-1.9-1 c-0.6-0.3-1.3-0.5-1.9-0.6c-0.7-0.1-1.4-0.2-2.2-0.2c-2.9,0-5.6,1.2-7.6,3.1c-2.6,2.5-3.8,6.2-3,9.7c0.7,3.6,3.2,6.5,6.6,7.8 c1.3,0.6,2.7,0.8,4.1,0.9c2.9,0,5.6-1.1,7.6-3.1C312.8,341.1,313.9,338.3,313.9,335.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_15_",
    className: "st5",
    d: "M776.9,669.2c-5.9,0-10.8-4.8-10.8-10.8V249.3c0-5.9-4.8-10.8-10.8-10.8H324.7 c-5.9,0-10.8,4.8-10.8,10.8c0,5.9-4.8,10.8-10.8,10.8c-5.9,0-10.8-4.8-10.8-10.8c0-17.8,14.5-32.3,32.3-32.3h430.7 c17.8,0,32.3,14.5,32.3,32.3v409.1C787.6,664.4,782.8,669.2,776.9,669.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_16_",
    className: "st5",
    d: "M227.8,669.2c-5.9,0-10.8-4.8-10.8-10.8v-96.9c0-17.8,14.5-32.3,32.3-32.3h53.8 c5.9,0,10.8,4.8,10.8,10.8c0,5.9-4.8,10.8-10.8,10.8h-53.8c-5.9,0-10.8,4.8-10.8,10.8v96.9C238.5,664.4,233.7,669.2,227.8,669.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_17_",
    className: "st5",
    d: "M852.2,669.2c-5.9,0-10.8-4.8-10.8-10.8v-96.9c0-5.9-4.8-10.8-10.8-10.8h-53.8 c-5.9,0-10.8-4.8-10.8-10.8c0-5.9,4.8-10.8,10.8-10.8h53.8c17.8,0,32.3,14.5,32.3,32.3v96.9c0,2.9-1.1,5.6-3.2,7.6 C857.8,668.1,855.1,669.2,852.2,669.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_18_",
    className: "st5",
    d: "M486.2,636.9c-15.5,0-30.3-6.7-40.5-18.4l-75.4-86.1c-19.6-22.4-17.3-56.4,5.1-76 s56.4-17.3,76,5.1l31.3,35.8l143.3-193.8c11.3-15.7,30.3-24.1,49.5-22c19.3,2.1,35.9,14.4,43.6,32.2c7.7,17.8,5.2,38.3-6.5,53.8 l-183,247.6c-9.7,13.1-24.8,21.2-41.1,21.8L486.2,636.9z M410.7,464.6c-12.7,0-24.1,7.4-29.4,19c-5.2,11.5-3.2,25.1,5.1,34.6 l75.4,86.1c6.1,7,15,11,24.3,11l1.3,0c9.8-0.4,18.9-5.2,24.7-13.1l183-247.6c10.6-14.3,7.6-34.6-6.8-45.2 c-14.3-10.6-34.6-7.6-45.2,6.8L492,520.8c-1.9,2.6-5,4.2-8.2,4.4s-6.4-1.2-8.5-3.7l-40.1-45.9c-5.6-6.5-13.6-10.4-22.2-11 C412.2,464.6,411.5,464.6,410.7,464.6L410.7,464.6z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 75,
    className: "st6",
    width: 20,
    height: 58.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 452.5,
    y: 75,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 566.75 -358.25)",
    className: "st6",
    width: 20,
    height: 58.5
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 225.5,
    cy: 288.5,
    r: 17.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 902,
    cy: 772.8,
    r: 17.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 124.8,
    y: 698,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 544.0463 117.0757)",
    className: "st6",
    width: 11.8,
    height: 34.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.8,
    y: 698,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 728.8843 1128.6057)",
    className: "st6",
    width: 11.8,
    height: 34.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 733.5,
    y: 166.5,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 343.9304 -469.196)",
    className: "st6",
    width: 9.6,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.5,
    y: 166.5,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 1388.0935 -213.8417)",
    className: "st6",
    width: 9.6,
    height: 28.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 638.3,
    y: 883.4,
    transform: "matrix(0.5243 0.8515 -0.8515 0.5243 1084.9116 -118.0116)",
    className: "st6",
    width: 19.6,
    height: 57.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.3,
    y: 883.4,
    transform: "matrix(-0.8515 0.5243 -0.5243 -0.8515 1678.1685 1348.8984)",
    className: "st6",
    width: 19.6,
    height: 57.4
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 973.9,
    y: 430.4,
    transform: "matrix(-0.323 0.9464 -0.9464 -0.323 1714.8861 -338.6367)",
    className: "st6",
    width: 9.3,
    height: 27.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 973.9,
    y: 430.4,
    transform: "matrix(-0.9464 -0.323 0.323 -0.9464 1761.2292 1180.3574)",
    className: "st6",
    width: 9.3,
    height: 27.3
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyNews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-news.dfbfee53.svg";
export { ForwardRef as ReactComponent };